import { createFileRoute } from '@tanstack/react-router'

import { DepartmentListPage, entityOptionsQueryOptions } from '@/systems/user-management'

export const Route = createFileRoute('/user-management/departments')({
  // Entities list drives the entity selector; prefetching here means it's
  // already in cache when the page renders, so the dropdown isn't blank on
  // first paint. Departments themselves are not prefetched because the
  // entityId isn't known until the user (or the default-pick effect) chooses.
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(entityOptionsQueryOptions())
  },
  component: DepartmentListPage,
})
